import { getWithIDToken, postWithIdToken, IMSTokenParams } from "@utils/http/MSAuthAPI";
import { Country } from '@utils/constants/localisation';
import { AddDocumentRequest, IAddDocumentResponse, IManualUploadResponse, ManualUploadRequest } from '../identityVerification/IdentityVerification.types';

// We can use alternateHost to point to localhost for testing
//const alternateHost = 'http://localhost:5000';
const alternateHost = '';

interface IIdentityVerificationService {
    getCustomerIdentityVerification(customerId: string, country: Country, IDTokenParams: IMSTokenParams, showOnlyLatest?: boolean): Promise<any>
    initiateIdentityVerificationCheck(customerId: string, country: Country, skipInDateCheck: boolean, IDTokenParams: IMSTokenParams): Promise<any>
    prepareManualUpload(request: ManualUploadRequest, IDTokenParams: IMSTokenParams): Promise<IManualUploadResponse>
    addDocumentToExistingCheck(request: AddDocumentRequest, IDTokenParams: IMSTokenParams): Promise<IAddDocumentResponse>
}

const IdentityVerificationService: IIdentityVerificationService = {
    async getCustomerIdentityVerification(customerId: string, country: Country, IDTokenParams: IMSTokenParams, showOnlyLatest?: boolean): Promise<any> {
        const params: { show_only_latest?: string } = {show_only_latest: showOnlyLatest ? 'true' : 'false'};

        const resp = await getWithIDToken(
            `${alternateHost}/v1/identity-verification-check/customer/${country}/${customerId}`,
            IDTokenParams,
            params
        );

        if (resp.status >= 500) {
            throw new Error('Server error');
        }

        return resp.data;
    },

    async initiateIdentityVerificationCheck(customerId: string, country: Country, skipInDateCheck: boolean, IDTokenParams: IMSTokenParams): Promise<any> {
        const resp = await postWithIdToken(
            `${alternateHost}/v1/identity-verification-check`,
            IDTokenParams,
            {},
            {
                country: country,
                zoho_contact_id: customerId,
                send_email: true,
                skip_in_date_ivc_document_check: skipInDateCheck
            }
        );

        if (resp.status >= 500) {
            throw new Error('Server error');
        }

        return resp.data;
    },

    async prepareManualUpload(request: ManualUploadRequest, IDTokenParams: IMSTokenParams): Promise<IManualUploadResponse> {
        const resp = await postWithIdToken(
            `${alternateHost}/v1/identity-verification-check/manualupload`,
            IDTokenParams,
            {},
            { ...request.toJSON() }
        );

        if (resp.status === 500) {
            throw new Error('Server error');
        }

        return resp.data;
    },

    async addDocumentToExistingCheck(request: AddDocumentRequest, IDTokenParams: IMSTokenParams): Promise<IAddDocumentResponse> {
        const resp = await postWithIdToken(
            `${alternateHost}/v1/identity-verification-check/add-document`,
            IDTokenParams,
            {},
            { ...request.toJSON() }
        );

        if (resp.status === 500) {
            throw new Error('Server error');
        }

        return resp.data;
    },
}

export default IdentityVerificationService;
